<app-register></app-register>

<div class="bg-intro-seed" [ngClass]="{'show': show}">
    <span class="icon-close" (click)="closeModal()"></span>
    <section class="gennius--intro intro-seed">
        <app-mena-carousel [images]="images" #carousel></app-mena-carousel>
        <!-- <img loading="lazy" class="img-seed"  src="./assets/img/gennius/logo-seed-group.webp" alt="gennius"> -->
        <div class="content">
            <h1>Partnership</h1>
            <span class="text"><span>Gennius XYZ</span>, a leading global innovator in digital asset management and loyalty programs, is proud to announce a strategic partnership with <span>Seed Group, a company of the Private Office of Sheikh Saeed Bin Ahmed Al Maktoum. </span></span>

        </div>
        <div class="bl-botones">
            <!-- <button *ngIf="!itsMobile" class="btn-mena bg-info" (click)="openVideo('10')">Press release</button> -->

            <a class="btn-mena bg-info" href="https://seedgroup.com/news/seed-group-onboards-gennius-xyz-to-transform-the-digital-asset-ecosystem-in-mena/" target="_blank">Press release</a>
            <button class="btn-mena bg-watch" (click)="openVideo('11')">Watch video</button>
        </div>
        <!--  <div class="filter"></div> -->
        <video *ngIf="!itsMobile" autoplay="" preload="metadata" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/gennius/seed-group-header-video.webp">
            <source src="./assets/img/gennius/seed-group-header-video.mp4" type="video/mp4">
        </video>
        <video *ngIf="itsMobile" autoplay="" preload="metadata" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/gennius/cymi/bg-video.webp">
            <source src="./assets/img/gennius/seed-group-header-video.mp4" type="video/mp4">
        </video>
    </section>
</div>


<section class="turnkey-solution">
    <h2>
        Welcome to
        <img  src="./assets/img/cryptmi/miles-logo.svg" alt="">
    </h2>
    <p>The latest evolution of loyalty payments —an end-to-end solution that achieves more freedom to cardholders and less hassle for banks.</p>
    <div class="image">
        <img *ngIf="!itsMobile" src="./assets/img/gennius/turnkey-people.webp" class="">
        <img loading="lazy" *ngIf="itsMobile" src="./assets/img/gennius/mobile/turnkey-people.webp" class="" height="500">

        <button class="btn-seed" (click)="openModal()">
            <div>

            </div>
            <!-- <img loading="lazy" src="./assets/img/gennius/btn-seed-group.webp" alt=""> -->
        </button>
    </div>

    <img *ngIf="!itsMobile" class="turnkey-element turnkey-element--two" src="./assets/img/gennius/turnkey-element2.webp" ngxParallaxScroll
        [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"'
        [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
    <img *ngIf="!itsMobile" class="turnkey-element turnkey-element--three" src="./assets/img/gennius/turnkey-element3.webp" ngxParallaxScroll
        [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"'
        [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>


</section>


<section class="page-cymi video-platforms">
    <section class="first-child video-play">
        <div class="container">
            <div class="row">
                <div class="left">
                    <h2>Program preferences</h2>
                    <p>Loyalty programs from different accounts into one powerful Miles digital wallet for seamless management, redemption, and maximized choices on every purchase.</p>

                    <div class="video-description" (click)="actionVideo('1')">
                        <div  class="module-allex">
                            <img loading="lazy" src="./assets/img/gennius/icon-allex.gif" alt="" class="icon-allex">
                        </div>
                        <button class="btn-gennius btn-gennius--description">
                            <span class="icon" [ngClass]="{'icon-pause': play1, 'icon-play': !play1, 'show': !playVideo1}"></span> 
                            <video [ngClass]="{'show': playVideo1}" playsinline="" preload="metadata" poster="./assets/img/gennius/poster-audio.webp" class="video-vimeo video-mask1" (ended)="videoEnd('1')">
                                <source type="video/mp4" src="https://player.vimeo.com/progressive_redirect/playback/1016310604/rendition/240p/file.mp4?loc=external&signature=3b356e8ede6058848e05ba187aa2b993535b5959f8ed6f876a11a3b233253457">
                            </video>
                        </button>
                    </div>
                </div>
                <div class="right">
                    <div class="phone">
                        <div class="content">
                          <video class="video-vimeo" loop="loop" preload="metadata" onloadedmetadata="this.muted = true" playsinline="" poster="" autoplay="">
                            <source
                              src-tmp="https://player.vimeo.com/progressive_redirect/playback/856004892/rendition/540p/file.mp4?loc=external&signature=46dd0318ec2be5d82e7a97fc6902b0ed9834b6338a04508d274dde7bf6b8a8e4"
                              type="video/mp4">
                          </video>
                        </div>
                    </div>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-23" src="./assets/img/gennius/cymi/element-40.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-24" src="./assets/img/gennius/cymi/element-31.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-25" src="./assets/img/gennius/cymi/element-32.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-29" src="./assets/img/gennius/cymi/element-41.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>
    <section class="fund-middle second video-play">
        <div class="container">
            <div class="row">
                <div class="left">
                    <div class="phone">
                        <div class="content">
                          <video class="video-vimeo" loop="loop" preload="metadata" onloadedmetadata="this.muted = true" playsinline="" poster=""  autoplay="">
                            <source
                              src-tmp="https://player.vimeo.com/progressive_redirect/playback/856004900/rendition/540p/file.mp4?loc=external&signature=0f6e354ec3755fb071958c19d98039e173daba9fb6e2d6aa0dfb2eafe9745e74"
                              type="video/mp4">
                          </video>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <h2>Switch In</h2>
                    <p>Switch your cashback rewards from bank cards, wallets, loyalty programs, or digital assets to miles.</p>

                    <div class="video-description" (click)="actionVideo('2')">
                        <div  class="module-allex">
                            <img loading="lazy" src="./assets/img/gennius/icon-allex.gif" alt="" class="icon-allex">
                        </div>
                        <button class="btn-gennius btn-gennius--description">
                            <span class="icon" [ngClass]="{'icon-pause': play2, 'icon-play': !play2, 'show': !playVideo2}"></span>
                            <video [ngClass]="{'show': playVideo2}" class="video-vimeo video-mask2" playsinline="" preload="metadata" poster="./assets/img/gennius/poster-audio.webp" (ended)="videoEnd('2')">
                                <source
                                  src-tmp="https://player.vimeo.com/progressive_redirect/playback/1016310617/rendition/240p/file.mp4?loc=external&signature=d66ebcad0c6f9e132a80b9fa4ec45f34d0300ed486f694fb91caaa4dd3bd6614"
                                  type="video/mp4">
                              </video>
                        </button>
                    </div>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-27" src="./assets/img/gennius/cymi/element-33.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-28" src="./assets/img/gennius/cymi/element-34.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>
    <section class="third video-play">
        <div class="container">
            <div class="row">
                <div class="left">
                    <h2>Send your miles. <br>Share the love.</h2>
                    <p><strong>Transfer miles</strong> to friends and
                        family. Anytime, anywhere.</p>

                    <div class="video-description" (click)="actionVideo('3')">
                        <div  class="module-allex">
                            <img loading="lazy" src="./assets/img/gennius/icon-allex.gif" alt="" class="icon-allex">
                        </div>
                        <button class="btn-gennius btn-gennius--description">
                            <span class="icon" [ngClass]="{'icon-pause': play3, 'icon-play': !play3, 'show': !playVideo3}"></span>
                            <video [ngClass]="{'show': playVideo3}" class="video-vimeo video-mask3" playsinline="" preload="metadata" poster="./assets/img/gennius/poster-audio.webp" (ended)="videoEnd('3')">
                                <source
                                  src-tmp="https://player.vimeo.com/progressive_redirect/playback/1016310637/rendition/240p/file.mp4?loc=external&signature=4851415fa470683c30bb969cb9733e72867956cb74b76e515ad3a676d090f63c"
                                  type="video/mp4">
                            </video>
                        </button>
                    </div>
                </div>
                <div class="right">
                    <div class="phone">
                        <div class="content">
                          <video class="video-vimeo" loop="loop" preload="metadata" onloadedmetadata="this.muted = true" playsinline="" poster="" autoplay="">
                            <source
                              src-tmp="https://player.vimeo.com/progressive_redirect/playback/856004907/rendition/540p/file.mp4?loc=external&signature=971a2d8a6666e40929fa90d914a0934a129ca02ee1a3d8a0c4755c67e6d0b94d"
                              type="video/mp4">
                          </video>
                        </div>
                      </div>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-31" src="./assets/img/gennius/cymi/element-41.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-30" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-32" src="./assets/img/gennius/cymi/element-35.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>
    <section class="fund-middle fourth video-play">
        <div class="container">
            <div class="row">
                <div class="left">
                    <div class="phone">
                        <div class="content">
                          <video class="video-vimeo" loop="loop" preload="metadata" onloadedmetadata="this.muted = true" playsinline="" poster=""  autoplay="">
                            <source
                              src-tmp="https://player.vimeo.com/progressive_redirect/playback/856004919/rendition/540p/file.mp4?loc=external&signature=69eac52b27e6017da118c86d7da1126498bdb5c48beb1f6068ed31bf2389371c"
                              type="video/mp4">
                          </video>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <h2>Switch miles <br>to crypto</h2>
                    <p><strong>Switch or convert</strong> over 250 crypto coins within the Miles app from any existing crypto wallet, all while getting rewards. You can check the performance of your crypto coins over time within the Miles app.</p>

                    <div class="video-description" (click)="actionVideo('4')">
                        <div  class="module-allex">
                            <img loading="lazy" src="./assets/img/gennius/icon-allex.gif" alt="" class="icon-allex">
                        </div>
                        <button class="btn-gennius btn-gennius--description">
                            <span class="icon" [ngClass]="{'icon-pause': play4, 'icon-play': !play4, 'show': !playVideo4}"></span>
                            <video [ngClass]="{'show': playVideo4}" class="video-vimeo video-mask4" playsinline="" preload="metadata" poster="./assets/img/gennius/poster-audio.webp" (ended)="videoEnd('4')">
                                <source
                                  src-tmp="https://player.vimeo.com/progressive_redirect/playback/1016310656/rendition/240p/file.mp4?loc=external&signature=340d5d2585e5d7af93a9ce007d6ef1b047a65cdd6e01ea996c2497acfcf7caed"
                                  type="video/mp4">
                            </video>
                        </button>
                    </div>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-33" src="./assets/img/gennius/cymi/element-42.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-34" src="./assets/img/gennius/cymi/element-36.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>
    <section class="fifth video-play">
        <div class="container">
            <div class="row">
                <div class="left">
                    <h2>Shop and redeem
                        in app, in store or
                        contactless at
                        100M+ merchants
                        worldwide</h2>
                    <p><strong>Get unlimited access</strong> to the connected world of banks, airlines, hotels and
                        merchants everywhere.</p>

                        <p>Shop directly at preferred merchants.</p>

                     <div class="video-description" (click)="actionVideo('5')">
                        <div  class="module-allex">
                            <img loading="lazy" src="./assets/img/gennius/icon-allex.gif" alt="" class="icon-allex">
                        </div>
                        <button class="btn-gennius btn-gennius--description">
                            <span class="icon" [ngClass]="{'icon-pause': play5, 'icon-play': !play5, 'show': !playVideo5}"></span>
                            <video [ngClass]="{'show': playVideo5}" class="video-vimeo video-mask5" playsinline="" preload="metadata" poster="./assets/img/gennius/poster-audio.webp" (ended)="videoEnd('5')">
                                <source
                                  src-tmp="https://player.vimeo.com/progressive_redirect/playback/1016310665/rendition/240p/file.mp4?loc=external&signature=3e992694f3c87379195d9df86f04da149ffc22bf02c7f1f112aea676d6d4382e"
                                  type="video/mp4">
                            </video>
                        </button>
                    </div>
                </div>
                <div class="right">
                    <div class="phone">
                        <div class="content">
                          <video class="video-vimeo" loop="loop" preload="metadata" onloadedmetadata="this.muted = true" playsinline="" poster=""  autoplay="">
                            <source
                              src-tmp="https://player.vimeo.com/progressive_redirect/playback/856004959/rendition/540p/file.mp4?loc=external&signature=6fd0a0f569fd91809cce10251bddaeca7a59b4c1190da9958c954947ab3116fa"
                              type="video/mp4">
                          </video>
                        </div>
                      </div>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-35" src="./assets/img/gennius/cymi/element-43.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-36" src="./assets/img/gennius/cymi/element-38.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-37" src="./assets/img/gennius/cymi/element-37.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>
    <section class="fund-middle sixth video-play">
        <div class="container">
            <div class="row">
                <div class="left">
                    <div class="phone">
                        <div class="content">
                          <video class="video-vimeo" loop="loop" preload="metadata" onloadedmetadata="this.muted = true" playsinline="" poster=""  autoplay="">
                            <source
                              src-tmp="https://player.vimeo.com/progressive_redirect/playback/856004931/rendition/540p/file.mp4?loc=external&signature=0c4ba5c6f20e99d939d73ab39805ea5d37768c4a993cc7e72eb9308dfb2c0e70"
                              type="video/mp4">
                          </video>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <h2>Ready to dip your toes in the Web3 universe?</h2>
                    <p><strong>Use your rewards to buy NFTs</strong>, real estate, avatars or any virtual assets in the Metaverse with Open Sea, Decentraland, and many other Web3 marketplaces.</p>

                    <div class="video-description" (click)="actionVideo('6')">
                        <div  class="module-allex">
                            <img loading="lazy" src="./assets/img/gennius/icon-allex.gif" alt="" class="icon-allex">
                        </div>
                        <button class="btn-gennius btn-gennius--description">
                            <span class="icon" [ngClass]="{'icon-pause': play6, 'icon-play': !play6, 'show': !playVideo6}"></span>
                            <video [ngClass]="{'show': playVideo6}" class="video-vimeo video-mask6" playsinline="" preload="metadata" poster="./assets/img/gennius/poster-audio.webp" (ended)="videoEnd('6')">
                                <source
                                  src-tmp="https://player.vimeo.com/progressive_redirect/playback/1016310675/rendition/240p/file.mp4?loc=external&signature=d6511a73a98981f6a2cd6ae50181828e4ae67f30212618d23a960f7f688a9209"
                                  type="video/mp4">
                            </video>
                        </button>
                    </div>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-38" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-39" src="./assets/img/gennius/cymi/element-39.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>
</section>

<section class="turnkey-solution turnkey-solution--content">
    <div class="container">
        <div class="row">
            <div class="left">
                <h2>Turnkey solution</h2>
                <span class="text-gradient">for banks and merchants</span>
            </div>
            <div class="right">
                <p>We aim to develop a comprehensive turnkey solution for banks and merchants in the region. By providing <span>white-label solutions</span> that combine rewards, payments, and <span>Web3 features</span> into a single, holistic platform, we aim to increase revenue for issuers and provide unparalleled benefits for users.
                </p>
            </div>
        </div>
    </div>
</section>



<section class="payment-flows">
    <div class="container">
        <div class="row">
            <div class="left">
                <span class="new">New</span>
                <h2>Payment flows</h2>
                <span class="text-gradient">cross borders and <br> multiple currencies</span>
                <p>We want to enable new payment flows cross borders and multiple currencies. Our partnership seeks to facilitate seamless cross-border and <span>multi-currency transactions</span>, making it easier for businesses and consumers in the region to engage in international commerce.
                </p>
            </div>
            <div class="right">
                <div class="image-phones">
                    <img *ngIf="!itsMobile" src="./assets/img/gennius/phones-flows.webp" class="phones-flows">
                    <img loading="lazy" *ngIf="itsMobile" src="./assets/img/gennius/mobile/phones-flows.webp" class="phones-flows">
                    <img *ngIf="!itsMobile" src="./assets/img/gennius/flows-element.webp" class="flows-element">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="bg-video" [ngClass]="{'open': video11}">
    <div class="modal-general videointro">
        <video *ngIf="video11" class="main-intro3" autoplay="" oncanplay="this.play()" preload="metadata" controls
            poster="./assets/img/gennius/bg-intro3.webp">
            <source
                src-tmp="https://player.vimeo.com/progressive_redirect/playback/826784187/rendition/540p/file.mp4?loc=external&signature=e9e2ca46779070c522cfe9574e3ae9acc20c4cbb6cd330348a7d06f1db33cf2e"
                type="video/mp4">
        </video>
        <span class="icon-close" (click)="closeVideo('11')"></span>
    </div>

</div>


<app-footer></app-footer>

